<template>
  <div>
    <div class="content">
      <div class="title">
        <span>支付信息</span>
      </div>
      <ul>
        <li v-if="orderInfo.subjectName != '宝丰县人民医院'">
          <span>医院：</span>
          <span>{{ orderInfo.subjectName }}</span>
        </li>
        <li>
          <p>
            <span>处方号：</span>
            <span>{{ orderInfo.medicalAdviceCode }}</span>
          </p>
        </li>
        <li v-if="orderInfo.subjectName != '赵县妇幼保健院'">
          <div>
            <p>
              <span>科室：</span>
              <span>{{ orderInfo.creatorDeptName }}</span>
            </p>
            <p>
              <span>医师：</span>
              <span>{{ orderInfo.operateUser }}</span>
            </p>
          </div>
        </li>
        <li>
          <div>
            <p>
              <span>姓名：</span>
              <span>{{ orderInfo.patientName }}</span>
            </p>
            <p>
              <span>类型：</span>
              <!-- <span v-if="orderInfo.adviceType === 4">预交费</span> -->
              <span>营养医嘱</span>
              <!-- <span v-if="orderInfo.adviceType === 6">宣教医嘱</span> -->
            </p>
          </div>
        </li>
        <li>
          <span>开具日期：</span>
          <span>
            {{ $moment(orderInfo.createTime).format('YYYY-MM-DD HH:ss') }}
          </span>
        </li>
      </ul>
      <div>
        <div class="totalContent">
          <p class="title">处方支付金额</p>
          <p>
            <span style="color: var(--basic-green)">金额：</span>
            <span>￥{{ orderInfo.totalAmount || 0 }}</span>
            <span
              v-if="orderInfo.orderStatus === 1"
              style="color: var(--basic-red)"
            >
              未缴费
            </span>
            <span
              v-if="orderInfo.orderStatus === 2"
              style="color: var(--basic-red)"
            >
              支付中
            </span>
            <span
              v-if="orderInfo.orderStatus === 3"
              style="color: var(--basic-green)"
            >
              已支付
            </span>
            <span v-if="orderInfo.orderStatus === 4">退款中</span>
            <span v-if="orderInfo.orderStatus === 5">已退款</span>
            <span v-if="orderInfo.orderStatus === 6">已作废，请重新开具</span>
          </p>
        </div>
        <div
          v-if="
            orderInfo.subjectName == '长治医学院附属和平医院' &&
            orderInfo.prescriptionType == 2
          "
          style="margin-top: 10px"
        >
          <img src="@/assets/img/heping.jpg" alt="" />
        </div>
        <div class="btnContent">
          <van-button
            v-if="orderInfo.orderStatus === 1"
            @click="payBtn"
            round
            size="small"
            type="success"
          >
            立即支付
          </van-button>
          <van-button
            v-if="
              orderInfo.orderStatus === 3 &&
              (orderInfo.subjectName === '铭方健康管理平台' ||
                orderInfo.subjectName === '太和县人民医院' ||
                orderInfo.subjectName === '暨南大学附属第一医院')
            "
            @click="openInvoice"
            round
            size="small"
            type="success"
          >
            发票开具
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { reactive, toRefs, onMounted } from 'vue'
  import moment from 'moment'
  import { useRoute, useRouter } from 'vue-router'
  import { useWechat } from '@/utils/wechat'
  const route = useRoute()
  const router = useRouter()
  const state = reactive({
    orderInfo: '',
    medicalAdviceCode: route.query.adviceCode,
    category: route.query.category,
    receiveType: 2,
    receivingAddress: '',
    receivingRemark: '',
    receivingPhone: null,
    receivingUser: '',
    url: '',
    code: route.query.code,
    openid: route.query.openid,
    appId: '',
    paymentAddress: '',
    wechatUrl: '',
  })
  const { orderInfo } = toRefs(state)
  // 微信相关函数将在初始化后赋值
  let getWechatAppId, getWechatOpenId

  onMounted(async () => {
    await initializePage()
  })

  // 初始化页面数据
  const initializePage = async () => {
    try {
      // 初始化微信相关函数，使用正确的参数
      const wechatFuncs = useWechat(
        state.medicalAdviceCode,
        state.category,
        state.code,
        location.href.split('#')[0],
        // 'https://wx.sxmfyy.com/auth/baizhe.wechat-auth.top/pre/fx/pay?category=2&adviceCode=176774986642014',
      )

      getWechatAppId = wechatFuncs.getWechatAppId
      getWechatOpenId = wechatFuncs.getWechatOpenId

      // 获取微信appid
      try {
        const appData = await getWechatAppId()
        state.orderInfo = appData.data
        state.appId = appData.data.wxJsticket.appId
        state.wechatUrl = appData.data.wxJsticket.url
        console.log(state.wechatUrl)
      } catch (error) {
        console.log('获取微信APP ID失败:', error)
      }

      state.orderInfo.totalAmount = parseFloat(
        state.orderInfo.totalAmount || 0,
      ).toFixed(2)

      // 拿到code调用获取OpenId并且判断已支付的情况下不调用
      if (route.query.code && state.orderInfo.orderStatus == 1) {
        try {
          if (!getWechatOpenId) {
            console.error('微信OpenId函数未初始化')
            return
          }
          const openData = await getWechatOpenId()
          const responseData = JSON.parse(openData.data)
          wx.config({
            debug: false,
            appId: responseData.appId,
            timestamp: responseData.timeStamp,
            nonceStr: responseData.nonceStr,
            signature: responseData.paySign,
            jsApiList: ['chooseWXPay', 'checkJsApi'],
          })

          wx.ready(() => {
            wx.chooseWXPay({
              appId: responseData.appId,
              timestamp: responseData.timeStamp,
              nonceStr: responseData.nonceStr,
              package: responseData.package,
              signType: responseData.signType,
              paySign: responseData.paySign,
              success: function (payRes) {
                initializePage()
              },
              cancel: function (payRes) {
                console.log('取消支付', payRes)
              },
              fail: function (payRes) {
                console.log('支付失败', payRes)
              },
            })
          })
        } catch (error) {
          console.log('支付过程出错:', error)
        }
      }
    } catch (error) {
      console.error('页面初始化失败:', error)
    }
  }
  // 微信授权登录
  function wechatAuto() {
    const url = state.wechatUrl

    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
      state.appId
    }&redirect_uri=${encodeURIComponent(
      url,
    )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
  }

  // 支付方法
  async function payBtn() {
    wechatAuto()
  }

  // 开具发票
  const openInvoice = () => {
    localStorage.setItem('changeAdviceCode', state.orderInfo.medicalAdviceCode)
    router.push({ path: '/prescription/invoice' })
  }
</script>
<style lang="scss" scoped>
  .content {
    border: 1px solid var(--basic-border-color);
    border-top: none;

    .totalContent {
      .title {
        opacity: 0.5;
      }

      p:last-of-type {
        background: var(--basic-price);
        padding: 16px;
        // background: ;
        text-align: left;

        span {
          font-size: 17px;
          display: inline-block;
          width: 32%;
        }
      }
    }

    .title {
      height: 40px;
      padding-left: 10px;
      line-height: 40px;
      border-bottom: 1px solid var(--basic-border-color);

      span {
        padding: 2px 10px;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        background: var(--basic-green);
      }
    }

    ul {
      li {
        padding: 16px;
        border-bottom: 1px solid var(--basic-border-color);

        span:first-of-type {
          color: var(--basic-labe);
        }

        div {
          p {
            display: inline-block;
            width: 48%;
          }

          p:last-of-type {
            border: none;
            padding-left: 10px;
          }
        }
      }
    }
  }

  .btnContent {
    padding-top: 20px;
    width: 100%;
    text-align: center;
    position: fixed;
    background: #fff;
    bottom: 0;
    button {
      width: 80%;
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
    }
  }

  .seeInfoContent {
    padding: 10px 20px 20px 20px;
    text-align: center;

    button {
      width: 50%;
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
    }
  }
  ::v-deep .van-dialog__footer {
    display: none;
  }
  .button-content {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    button {
      width: 50% !important;
    }
  }
</style>
